<template>
    <CardPage :section="16" :page="6" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Good job getting these matched up! Remember that when drugs and alcohol are in the mix, you might do things you wouldn’t otherwise do. To keep your
            sexual health boundaries, think about how to anticipate this and have a plan for how to keep things sexy and safe! You’ve earned another sticker!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section16/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section16/complete', true);
            this.$store.set('section16/sticker@earned', true);
        }
    }
};
</script>
